<nav
  class="bg-surface-bg-generic-white px-4 py-1.5 border-b border-border-neutral-subtle lg:p-6 lg:border-b-0 lg:rounded-lg">
  <div class="flex items-center justify-between">
    <!-- Left Side: Menu Button + ARM Logo -->
    <div class="flex items-center gap-2">
      @if (showMenuButton()) {
      <button
        type="button"
        id="navbar_menu_btn"
        (click)="handleMenuClick()"
        class="flex items-center justify-center min-w-11 min-h-11 -ms-2 text-typography-neutral-solid hover:bg-surface-bg-neutral-subtle transition-all duration-200 rounded-lg cursor-pointer"
        aria-label="Open navigation menu"
        aria-haspopup="dialog"
        [attr.aria-expanded]="isMenuOpen()"
        [attr.aria-controls]="menuControlsId()">
        <lib-hamburger-icon
          width="24"
          height="24"
          color="currentColor"
          class="flex-shrink-0" />
      </button>
      }
      <lib-arm-logo width="64" class="flex-shrink-0" />
    </div>

    <!-- Right Side: Lock, Bell -->
    <div class="flex items-center gap-1 lg:gap-3">
      <!-- Lock Icon Button -->
      @if (isDataLocked()) {
      <!-- Data is ENCRYPTED (Locked) - RED -->
      <button
        type="button"
        (click)="handleLockClick()"
        class="inline-flex items-center justify-center min-w-11 min-h-11 lg:inline-block lg:min-w-0 lg:min-h-0 p-2 text-typography-neutral-active hover:text-icon-destructive-strong hover:bg-surface-bg-destructive-faint transition-all duration-200 rounded-lg cursor-pointer"
        aria-label="Security - Data Encrypted">
        <lib-lock-icon
          width="24"
          height="24"
          class="flex-shrink-0 text-icon-destructive-primary" />
      </button>
      } @else {
      <!-- Data is DECRYPTED (Unlocked) - GREEN -->
      <button
        type="button"
        (click)="handleLockClick()"
        class="inline-flex items-center justify-center min-w-11 min-h-11 lg:inline-block lg:min-w-0 lg:min-h-0 p-2 text-icon-success-primary hover:text-icon-success-strong hover:bg-surface-bg-success-faint transition-all duration-200 rounded-lg cursor-pointer"
        aria-label="Security - Data Decrypted">
        <lib-lock-icon
          width="24"
          height="24"
          class="flex-shrink-0 text-icon-success-primary" />
      </button>
      }

      <!-- Bell Icon Button -->
      <button
        type="button"
        (click)="handleBellClick()"
        class="inline-flex items-center justify-center min-w-11 min-h-11 lg:inline-block lg:min-w-0 lg:min-h-0 p-2 text-typography-neutral-active hover:text-icon-primary-strong hover:bg-surface-bg-primary-faint transition-all duration-200 rounded-lg cursor-pointer"
        aria-label="Notifications">
        <lib-bell-icon width="24" height="24" class="flex-shrink-0" />
      </button>
    </div>
  </div>
</nav>
